import asyncHandler from 'app/shared/util/asyncHandler';
import axios, { AxiosResponse } from 'axios';
import { CmsContentType } from '../utils/cms-constants';

export interface ICmsApi {
  // updateAppStylesFromCms(step: StepData): Promise<AxiosResponse<any>>;
  getPageContentFromCms(cmsPageContentType: string, contentType: string): Promise<AxiosResponse<any>>;
}

class CmsApi implements ICmsApi {
  async getPageContentFromCms(cmsPageContentType: string, contentType: CmsContentType = undefined): Promise<AxiosResponse<any>> {
    let pathVariable: string = cmsPageContentType;
    pathVariable += contentType ? "/" + contentType : ""
    return asyncHandler(
      axios.get('cms/page/' + pathVariable, {
        headers: {
          'Accept-Language': 'fr-FR',
        },
      })
    );
  }
}

const cmsApi = new CmsApi();
export { cmsApi };